import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ErrorBoundary from '../pages/ErrorBoundary';
import Layout from '../components/Layout';
const Nike = lazy(() => import('../pages/Nike'));
const Main = lazy(() => import('../pages/Main'));
const Check = lazy(() => import('../pages/Check'));
const NotFound = lazy(() => import('../pages/NotFound'));

const Router = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<div>Loading...</div>}>
          <Layout>
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/nike" element={<Nike />} />
              <Route path="/check" element={<Check />} />
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </Layout>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

//Router.propTypes = {};

export default Router;
